import { IComputedValue } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import { Pane, PaneType } from "../Types";
import { FeatherIcon } from "../ui/FeatherIcon";
import { Tooltip } from "../ui/Tooltip";
import { assert } from "../Utils";
import { activePaneStates } from "./CanvasState";
import { JSONRenderRoot } from "./JSONRender";
import { PaneBody } from "./PaneBody";
import { PaneTransformButton } from "./PaneHeader";
import { PaneHeaderBar } from "./PaneHeaderBar";

export const PaneLibrary = observer(
  ({
    paneId,
    paneComputed,
    isMaximized,
    focusOnMount,
  }: {
    paneId: string;
    paneComputed: IComputedValue<
      Extract<Pane, { type: PaneType.Library }> | undefined
    >;
    isMaximized: boolean;
    focusOnMount: boolean;
  }) => {
    const activePaneState = activePaneStates.get(paneId)!;
    assert(activePaneState.type === PaneType.Library);
    const outputBox = activePaneState.outputBoxes[0];
    const output = outputBox.get();

    const viewMode = activePaneState.viewMode.get();

    return (
      <>
        <PaneHeaderBar
          paneId={paneId}
          paneComputed={paneComputed}
          isMaximized={isMaximized}
        >
          <div className="grow" />
          {!isMaximized ? (
            <PaneTransformButton paneId={paneId} outputIndex={0} />
          ) : null}
        </PaneHeaderBar>
        <PaneBody viewMode={viewMode} paneComputed={paneComputed}>
          <div className="pt-2 pb-[7px] px-2 overflow-auto select-text">
            <JSONRenderRoot
              paneId={paneId}
              value={output[1]}
              initialCollapseLevel={1}
              withoutContextMenu={true}
            />
            <Tooltip content="library documentation">
              <a
                href="https://www.notion.so/paulshen/Library-pane-03f6cf4423264516a9559d1c2712f75b"
                target="_blank"
                rel="noreferrer"
                className="text-neutral-250 hover:text-neutral-400 absolute top-2 right-2"
              >
                <FeatherIcon icon="help-circle" size="sm" />
              </a>
            </Tooltip>
          </div>
        </PaneBody>
      </>
    );
  }
);
